/**
 * ES6 modal implementation to replace jquery modal
 */
 export default class ES6Modal {

	constructor(options) {
		this.options = options;
		this.modal = document.getElementById(options.modalId);

		if (this.modal) {
			this.center();
			this.size();
		}
	}

	open() {
		this.backdrop = this.createBackdrop();

		this.modal.style.display = "block";

		this.modal.classList.add("show");

		document.body.classList.add("modal-open");

		this.disableClose();

		this.removeModalScrollingForMobile();

		// remove hash from url
		setTimeout(() => {
			history.pushState("", document.title, window.location.pathname);
		}, 1);
	}

	close() {
		this.backdrop.remove();

		this.modal.style.display = "none";
		this.modal.classList.remove("show");

		document.body.classList.remove("modal-open");

		this.enableClose();

		// remove hash from url
		setTimeout(() => {
			history.pushState("", document.title, window.location.pathname);
		}, 1);
	}

	disableClose() {
		document.body.style.overflowY = 'hidden';// disable scrollbar

		// Temporary comented out, to prevent lnd styles from being broken
		// document.body.style.position = 'fixed'; // disable scroll on mobile devices

		this.modal.style.overflowY = 'auto';
		this.modal.style.overflowX = 'hidden';

		// todo convert this when we have a button case
		// $('#' + this.id).find('.modal-header button').attr('disabled', 'disabled');
	}

	enableClose() {
		document.body.style.overflowY = 'auto';// enable scrollbar
		document.body.style.position = 'static';// set default position

		this.modal.style.overflow = 'auto';

		// todo convert this when we have a button case
		// $('#' + this.id).find('.modal-header button').removeAttr('disabled');
	}

	createBackdrop() {
		let backdropDiv = document.createElement('div');
		backdropDiv.classList.add("modal-backdrop", "fade", "show");
		backdropDiv.style.display = "block";
		return document.body.appendChild(backdropDiv);
	}

	center() {
		let center = this.options.center ? this.options.center : 'vertical';
		if (center === 'vertical') {
			let modalDialog = this.modal.querySelector('.modal-dialog');
			modalDialog.classList.add("modal-dialog-centered");
		}
	}

	size() {
		let size = this.options.size ? this.options.size : '';
		if (size) {
			if (size === 'large') {
				let modalDialog = this.modal.querySelector('.modal-dialog');
				modalDialog.classList.add("modal-lg");
			}
		}
	}

	removeModalScrollingForMobile() {
		let removeModalScrollingForMobile = this.options.removeModalScrollingForMobile ? this.options.removeModalScrollingForMobile : false;
		if (removeModalScrollingForMobile) {
			// remove Modal scrolling on mobile devices - https://github.com/twbs/bootstrap/issues/15852
			this.modal.style.height = null;
		}
	}
}